"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PropertyCardActionAreaMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _DropdownIcon = require("../../components/DropdownIcon/DropdownIcon.styles");
var _spaceMixin = require("../spaceMixin");
/** @class PropertyCardActionAreaMixin */
/** @method */
var PropertyCardActionAreaMixin = function PropertyCardActionAreaMixin(props) {
  return (0, _styledToken.default)({
    columnGap: 'PropertyCard.action.columnGap',
    iconSize: 'PropertyCard.action.icon.size'
  }, function (_ref) {
    var columnGap = _ref.columnGap,
      iconSize = _ref.iconSize;
    return (0, _styledComponents.css)(["grid-area:actions;display:grid;grid-auto-flow:column;grid-column-gap:", ";justify-content:end;", " > svg{width:", "px;height:", "px;}"], columnGap ? columnGap + "px" : (0, _spaceMixin.spaceMixin)('sm')(props), _DropdownIcon.StyledDropdownIcon, iconSize, iconSize);
  });
};
exports.PropertyCardActionAreaMixin = PropertyCardActionAreaMixin;